import React from "react";
import { TriangulaLogo } from "@KristianIV/common-ui";
import styles from "./Brand.module.css";

/** The Triangula logo with the product word; the nav links it home, the login page shows it above the card. */
const Brand = () => (
  <span className={styles.brand}>
    <TriangulaLogo />
    <span className={styles.product}>Dashboard</span>
  </span>
);

export default Brand;
